import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { user } from './user.reducer';
import { entitlements } from './entitlements.reducer';
import { alert } from './alert.reducer';
import { cs2Submission }  from './cs2Submission.reducer';
import { cs2FileUpload } from './cs2FileUpload.reducer';
import { cs2Firm } from './cs2Firm.reducer';
import { cs2FileLog } from './cs2FileLog.reducer';
    
const rootReducer = (history) => combineReducers({
	router: connectRouter(history),
    authentication,
    registration,
    user,
    entitlements,
    alert,
    cs2Submission,
    cs2FileUpload,
    cs2Firm,
    cs2FileLog
});

export default rootReducer;